import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateSitterProfileRequest } from 'happypaws-shared/src/Sitter/models/UpdateSitterProfileRequest';
import { api } from '../../services/api';

export const useUpdateSitterProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateSitterProfileRequest) => {
      const response = await api.patch('/sitters/profile', data);
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['sitterProfile'] });
    },
  });
};
